var map = {
	"./Discount.png": "6857",
	"./DiscountA.png": "89b9",
	"./act-list-empty.png": "fe94",
	"./act-toTop-hover.png": "c1a0",
	"./agent.png": "2734",
	"./agentA.png": "4e4f",
	"./bg_site_bottom01.png": "44375",
	"./bg_site_top01.png": "4f88",
	"./bg_site_y01.png": "1352",
	"./cupLeft.png": "4e2e",
	"./cupRight.png": "6399",
	"./icon-success.png": "a152",
	"./login-close2.png": "87b1",
	"./mall.png": "704c",
	"./mallA.png": "7bda",
	"./refresh.png": "b379",
	"./register.png": "8d3a",
	"./registerA.png": "e14d",
	"./server.png": "33c9",
	"./serverA.png": "89f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "491b";